import { isNotEmpty } from 'aos-helpers/src/helpers/FormValidation'
import { DateTime } from 'aos-helpers/src/helpers/Time'

import { TaskTemplate } from '../task'
import { BrushesBrand } from '../task/BrushesBrand'
import { BrushesVehicle } from '../task/BrushesVehicle'
import { MaintenanceJob, MaintenanceTask, MaintenanceTaskType } from '../task/MaintenanceTask'
import { TaskType } from '../TaskType'
import {
    BaseTaskFormPayload,
    baseTaskFormPayloadFromTask,
    BaseTaskPayloadValidation,
    baseValidateTask,
    initialBaseTaskPayload,
} from './BaseTaskFormPayload'

export interface MaintenanceTaskFormPayload extends BaseTaskFormPayload {
    type: TaskType.Maintenance
    assignments: MaintenanceJobAssignmentPayload[]
    // billable: boolean
    // contractors: MaintenanceContractorPayload[]
}

export interface MaintenanceContractorPayload {
    name?: string
    contractTime?: DateTime | string
    jobStart?: DateTime | string
    jobEnd?: DateTime | string
    numberOfWorkers?: number
    uuid?: string
}

export interface MaintenanceJobAssignmentPayload {
    job?: MaintenanceJob
    brushesVehicle?: BrushesVehicle
    newBrushVehicle?: string
    brushesBrand?: BrushesBrand
    engineLastShiftHours?: number
    brushesLastShiftHours?: number
    totalHours?: number
    uuid?: string
}

export const initialMaintenanceTaskPayload: MaintenanceTaskFormPayload = {
    type: TaskType.Maintenance,
    ...initialBaseTaskPayload,
    assignments: [],
}

interface MaintenanceJobAssignmentPayloadValidation {
    job: boolean
    brushesVehicle?: boolean
    brushesBrand?: boolean
    engineLastShiftHours?: boolean
    brushesLastShiftHours?: boolean
    totalHours?: boolean
}

export interface MaintenanceTaskPayloadValidation extends BaseTaskPayloadValidation {
    assignments: MaintenanceJobAssignmentPayloadValidation[]
}

const isValidNumberOfHours = (hours: any): boolean => isNotEmpty(hours) && hours >= 0

const assignmentsValidation = (
    payload: MaintenanceTaskFormPayload,
): MaintenanceJobAssignmentPayloadValidation[] => {
    const brushes = payload.assignments.filter(a => a?.job?.jobType === MaintenanceTaskType.Brushes)
    const other = payload.assignments.filter(a => a?.job?.jobType !== MaintenanceTaskType.Brushes)

    return [
        ...brushes?.map(a => ({
            job: isNotEmpty(a?.job),
            brushesVehicle: isNotEmpty(a?.brushesVehicle),
            brushesBrand: isNotEmpty(a?.brushesBrand),
            engineLastShiftHours: isValidNumberOfHours(a?.engineLastShiftHours),
            brushesLastShiftHours: isValidNumberOfHours(a?.brushesLastShiftHours),
            totalHours: isValidNumberOfHours(a?.totalHours),
        })),
        ...other?.map(a => ({
            job: isNotEmpty(a?.job),
            brushesVehicle: true,
            brushesBrand: true,
            totalHours: true,
            engineLastShiftHours: true,
            brushesLastShiftHours: true,
        })),
    ].filter(Boolean)
}

export const validateMaintenanceTask = (
    t: MaintenanceTaskFormPayload,
): MaintenanceTaskPayloadValidation => ({
    ...baseValidateTask(t),
    assignments: t.assignments.length ? assignmentsValidation(t) : [{ job: false }],
})

export const maintenanceTaskFormPayloadFromTask = (
    t: MaintenanceTask | TaskTemplate<MaintenanceTask>,
    isClone = false,
): MaintenanceTaskFormPayload => ({
    type: TaskType.Maintenance,
    ...baseTaskFormPayloadFromTask(t, isClone),
    assignments: t.assignments ?? [],
})
